import React, { useMemo, useState } from 'react';
import { ExpressCheckoutElement } from '@stripe/react-stripe-js';
import { Frame, SageClassnames } from '@kajabi/sage-react';

import { useCheckout } from '../../context';
import * as CheckoutService from '../../services/CheckoutService';

const EXPRESS_CHECKOUT_OPTIONS = {
  buttonHeight: 40,
  buttonTheme: {
    applePay: 'white-outline',
  },
  layout: {
    overflow: 'never',
    maxColumns: 1,
  },
};

const TITLE_STYLING = {
  position: 'absolute',
  top: -10,
  textAlign: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
  left: 0,
  right: 0,
  width: 133,
  backgroundColor: 'white',
};

const Line = () => {
  const style = {
    backgroundColor: '#ECEEEF',
    flex: 1,
    height: 1,
  };
  return <span style={style}>&nbsp;</span>;
};

export const ExpressCheckout = () => {
  const {
    planInfo: { cardless, plan },
    expressCheckoutEnabled,
    handleExpressCheckout,
    setErrors,
    successfulExpressCheckout,
    submittingForm,
    trackAnalytics,
  } = useCheckout();

  const [canExpressCheckout, setCanExpressCheckout] = useState(false);
  const [paymentType, setPaymentType] = useState(null);

  const handleCancel = () => {
    trackAnalytics('Express Checkout Canceled', { payment_type: paymentType });
  };

  const handleClick = ({ expressPaymentType, resolve }) => {
    setPaymentType(expressPaymentType);
    trackAnalytics('Express Checkout Clicked', { payment_type: expressPaymentType });
    if (!submittingForm) {
      setErrors({});
      resolve({ emailRequired: true });
    }
  };

  const handleReady = ({ availablePaymentMethods }) => {
    setCanExpressCheckout(!!Object.values(availablePaymentMethods || {}).filter(Boolean).length);
  };

  const frameProps = useMemo(() => {
    if (canExpressCheckout) {
      return {
        border: Frame.BORDERS.DEFAULT,
        borderRadius: Frame.BORDER_RADII.MD,
        padding: Frame.PADDINGS.MD,
      };
    }
    return {};
  }, [canExpressCheckout]);

  if (!expressCheckoutEnabled || successfulExpressCheckout || cardless) {
    return null;
  }

  return (
    <Frame align={Frame.ALIGNMENTS.TOP_CENTER}>
      <Frame {...frameProps} style={{ position: 'relative' }}>
        {canExpressCheckout && (
          <p
            className={[
              SageClassnames.TYPE.BODY_SMALL,
              SageClassnames.TYPE_COLORS.CHARCOAL_300,
            ].join(' ')}
            style={TITLE_STYLING}
          >
            Express checkout
          </p>
        )}
        <ExpressCheckoutElement
          onCancel={handleCancel}
          onClick={handleClick}
          onConfirm={handleExpressCheckout}
          onReady={handleReady}
          options={EXPRESS_CHECKOUT_OPTIONS}
          className="sage-frame--width-fill"
        />
      </Frame>
      {canExpressCheckout && (
        <Frame
          align={Frame.ALIGNMENTS.CENTER_CENTER}
          direction={Frame.DIRECTIONS.HORIZONTAL}
          gap={Frame.GAPS.XS}
          width={Frame.WIDTHS.FILL}
        >
          <Line />
          <p
            className={[
              SageClassnames.TYPE.BODY_SMALL,
              SageClassnames.TYPE_COLORS.CHARCOAL_200,
            ].join(' ')}
          >
            Or continue below
          </p>
          <Line />
        </Frame>
      )}
    </Frame>
  );
};
